import { render } from "./KpsGuardRulesViolationsView.vue?vue&type=template&id=5ebad1d9&scoped=true"
import script from "./KpsGuardRulesViolationsView.vue?vue&type=script&lang=js"
export * from "./KpsGuardRulesViolationsView.vue?vue&type=script&lang=js"

import "./KpsGuardRulesViolationsView.vue?vue&type=style&index=0&id=5ebad1d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebad1d9"]])

export default __exports__